import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-analytics-allowances',
    templateUrl: './analytics-allowances.component.html',
    styleUrls: ['./analytics-allowances.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnalyticsAllowancesComponent {
  @Input() analytics: any;
}
